// Registers the forked Wheels components globally, so templates can use
// <WheelsSvgIcon>, <WheelsItineraryItem> and friends without importing them.
//
// Forked from @charterup/wheels-library 0.1.26; see WHEELS-FORK.md.
import WheelsAddressPicker from '@/components/WheelsAddressPicker/WheelsAddressPicker.vue'
import WheelsButton from '@/components/WheelsButton/WheelsButton.vue'
import WheelsDatePicker from '@/components/WheelsDatePicker/WheelsDatePicker.vue'
import WheelsDigitalTimePicker from '@/components/WheelsDigitalTimePicker/WheelsDigitalTimePicker.vue'
import WheelsItineraryEditor from '@/components/WheelsItineraryEditor/WheelsItineraryEditor.vue'
import WheelsItineraryItem from '@/components/WheelsItineraryItem/WheelsItineraryItem.vue'
import WheelsItineraryItemAddress from '@/components/WheelsItineraryItem/WheelsItineraryItemAddress.vue'
import WheelsItineraryItemDropoffTime from '@/components/WheelsItineraryItem/WheelsItineraryItemDropoffTime.vue'
import WheelsItineraryItemPickupTime from '@/components/WheelsItineraryItem/WheelsItineraryItemPickupTime.vue'
import WheelsStepwiseIndicator from '@/components/WheelsStepwiseIndicator/WheelsStepwiseIndicator.vue'
import WheelsSvgIcon from '@/components/WheelsSvgIcon/WheelsSvgIcon.vue'
import WheelsTimeInput from '@/components/WheelsTimeInput/WheelsTimeInput.vue'
import WheelsToggle from '@/components/WheelsToggle/WheelsToggle.vue'
import WheelsTripMapPoint from '@/components/WheelsTripMap/WheelsTripMapPoint.vue'
import WheelsTripRequirements from '@/components/WheelsTripRequirements/WheelsTripRequirements.vue'

import * as throttleUtils from '@/utils/throttle'
import * as timeStringUtils from '@/utils/timeStrings'

import '@/scss/wheels/wheels.scss'

const wheelsComponents = {
  WheelsAddressPicker,
  WheelsButton,
  WheelsDatePicker,
  WheelsDigitalTimePicker,
  WheelsItineraryEditor,
  WheelsItineraryItem,
  WheelsItineraryItemAddress,
  WheelsItineraryItemDropoffTime,
  WheelsItineraryItemPickupTime,
  WheelsStepwiseIndicator,
  WheelsSvgIcon,
  WheelsTimeInput,
  WheelsToggle,
  WheelsTripMapPoint,
  WheelsTripRequirements,
}

export const WheelsPlugin = {
  install: function (Vue: any, options?: { debug?: boolean }) {
    if (options?.debug) {
      console.log('wheels installing')
    }
    for (const key in wheelsComponents) {
      if (options?.debug) {
        console.log('wheels installing', key)
      }
      Vue.component(key, wheelsComponents[key as keyof typeof wheelsComponents])
    }
    // Preserved from upstream. Nothing in this app reads `$wheels`; the same
    // helpers are importable from '@/utils/throttle' and '@/utils/timeStrings'.
    Vue.prototype.$wheels = {
      ...throttleUtils,
      ...timeStringUtils,
    }
  },
}

export default WheelsPlugin
